import axios from 'axios';

/**
 * fetch() arayuzunu koruyan, altta axios kullanan API istemcisi.
 *
 * NEDEN: Uygulamanin 401 yakalama ve OTOMATIK TOKEN YENILEME mantigi axios
 * interceptor'larinda. Dogrudan fetch() ile yapilan cagrilar bu zincirin
 * disinda kaliyordu; access token 15 dakikada bir dolduğu icin bu cagrilar
 * sessizce 401 alip bos veri donuyordu (kullaniciya hicbir sey soylenmeden).
 *
 * Cagri yerlerini axios semantigine cevirmek yerine fetch'in Response seklini
 * taklit ediyoruz; boylece mevcut `res.ok` / `await res.json()` kullanimlari
 * degismeden calisiyor.
 *
 * Farklar (kasitli):
 *  - Authorization basligi GONDERILMEZ; axios interceptor'i her istekte GUNCEL
 *    token'i ekler. Cagri yerindeki elle okunan token bayat olabilirdi.
 *  - Ag hatasi disindaki HTTP hatalari (4xx/5xx) exception firlatmaz, tipki
 *    fetch gibi ok:false olarak doner.
 */

/** fetch Response'una benzeyen hafif nesne */
function responseShim(status, data, headers = {}) {
  const bodyText = typeof data === 'string' ? data : JSON.stringify(data ?? null);
  return {
    ok: status >= 200 && status < 300,
    status,
    statusText: String(status),
    headers: new Map(Object.entries(headers || {})),
    json: async () => (typeof data === 'string' ? JSON.parse(data) : data),
    text: async () => bodyText,
    blob: async () => new Blob([bodyText]),
  };
}

/** init.body -> axios data */
function normalizeBody(body) {
  if (body === undefined || body === null) return undefined;
  if (typeof FormData !== 'undefined' && body instanceof FormData) return body;
  if (typeof Blob !== 'undefined' && body instanceof Blob) return body;
  return body; // JSON string veya duz nesne — axios ikisini de gonderir
}

/** Cagri yerinin verdigi Authorization basligini at (interceptor guncelini koyar) */
function stripAuthHeader(headers) {
  if (!headers) return undefined;
  const out = {};
  for (const [k, v] of Object.entries(headers)) {
    if (k.toLowerCase() === 'authorization') continue;
    out[k] = v;
  }
  return out;
}

/**
 * @param {string} url
 * @param {RequestInit} [init]
 * @returns {Promise<object>} fetch benzeri Response
 */
export async function apiFetch(url, init = {}) {
  try {
    // DIKKAT: validateStatus'u EZMIYORUZ. axios'un 4xx/5xx'te reddetmesi sart,
    // cunku 401 yakalama ve token yenileme mantigi response interceptor'inin
    // HATA dalinda calisiyor. validateStatus: () => true dersek interceptor hic
    // devreye girmez ve bu sarmalayicinin tum amaci bosa cikar.
    const response = await axios({
      url,
      method: (init.method || 'GET').toUpperCase(),
      data: normalizeBody(init.body),
      headers: stripAuthHeader(init.headers),
      signal: init.signal,
    });
    return responseShim(response.status, response.data, response.headers);
  } catch (error) {
    // Buraya HTTP hatalari da duser. Interceptor 401'de yenilemeyi zaten
    // denedi; hala hatalıysa cagri yerine fetch gibi ok:false donuyoruz.
    if (error.response) {
      return responseShim(error.response.status, error.response.data, error.response.headers);
    }
    throw error; // ag hatasi / iptal
  }
}

export default apiFetch;
